import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class VendorService {

    static getVendor(item) {

        let api = `${API_BASE_URL}${API_PATHS.getvendor}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
          if (item?.service) params.append("service", item.service);
           if (item?.search) params.append("search", item.search);
       
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addVendor(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addvendor}`;
        return axiosInstance
            .post(api, data)

    }

    static editVendor(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editvendor}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteVendor(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deletevendor}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default VendorService;
